import React from 'react';
import labo from '../../images/Labo.jpg'; // Import your image
import sports from '../../images/Sports.jpg'; // Import your image
import mentor from '../../images/121.png'; // Import your image
import smart from '../../images/image.png'; // Import your image
import iit from '../../images/logo-bg.png'
import './Facilities.css'; // Import your custom CSS file

const Facilities = () => {
  return (
    <div className="facilities-container">

<h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}>
          Facilities
        </span>
      </h1>
      {/* First Section */}
      <div className="section">
        <div className="image">
          <img src={iit} alt="Description" />
        </div>
        <div className="content">
          <h2>IIT / NEET</h2>
        </div>
      </div>
      <div className="section">
        <div className="image">
          <img src={labo} alt="Description" />
        </div>
        <div className="content">
          <h2>Laboratory</h2>
        </div>
      </div>
      {/* Second Section */}
      <div className="section">
        <div className="image">
          <img src={sports} alt="Description" />
        </div>
        <div className="content">
          <h2>Sports</h2>
        </div>
      </div>
      {/* Third Section */}
      <div className="section">
        <div className="image" >
          <img src={smart} alt="Description" />
        </div>
        <div className="content">
          <h2>Smart Classes</h2>
        </div>
      </div>
      {/* Fourth Section */}
      <div className="section">
        <div className="image">
          <img src={mentor} alt="Description" />
        </div>
        <div className="content">
          <h2>Mentorship / Special Classes</h2>
        </div>
      </div>
    </div>
  );
};

export default Facilities;
